var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"wbpv-frame-container",class:_vm.containerClass},[_c('aside',{staticClass:"wbpv-frame",class:_vm.frameClass,style:({ height: _vm.pixelHeight })},[_vm._t("frame-content")],2),_vm._v(" "),_c('div',{ref:"frameContent",staticClass:"wbpv-frame-content",class:_vm.contentClass},[_vm._t("main-content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249cad51","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FrameContainer.vue
// module id = null
// module chunks = 